/**
 * Carries the pathkey digest to the player's own fetches.
 *
 * A pathkey protects a media page and, by acquisition, every child under it, so
 * the stream URL and subtitle tracks need it too — not just the content request.
 * Embeds send it as a request parameter because browsers discard cookies written
 * inside a third-party iframe. A context, not a prop chain, so the media page
 * (which never has one) renders no provider and is unaffected.
 *
 * @module helpers/pathKey
 */
import { createContext, useContext } from 'react';

// jyu.pathkey's COOKIE_NAME, which it also accepts as a request parameter.
const PATH_KEY_PARAM = 'path_key';

export const PathKeyContext = createContext(null);

export const usePathKey = () => useContext(PathKeyContext);

// Only when one is actually held: a wrong or empty path_key overrides a cookie
// that would otherwise have been accepted.
export const withPathKeyParam = (url, pathKey) =>
  pathKey
    ? `${url}${url.includes('?') ? '&' : '?'}${PATH_KEY_PARAM}=${encodeURIComponent(pathKey)}`
    : url;
